import * as React from "react";
import * as ReactDOM from "react-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faUser } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { variables, validEmail } from '../Variables';
import { ConfirmSynchronization } from "./ConfirmSynchronization";
import { MultiSelect } from "react-multi-select-component";

const { useState } = React;

export const Settings = ({ showMessage, clientSettings }) => {
    const whiseUserToken = useSelector(state => state.whiseUser.whiseToken);
    const reduxClientToken = useSelector(state => state.whiseClientToken.whiseClientToken);
    const user = useSelector(state => state.user.user);
    const actions = useSelector(state => state.calendarActions.calendarActions);
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);
    const reduxSelectedLanguage = useSelector(state => state.selectedLanguageTranslations.selectedLanguage);

    const [clientId, setClientId] = useState(user.user.clientId);
    const [officeId, setOfficeId] = useState(user.user.officeId);
    const [settingId, setSettingId] = useState("");
    const [office, setOffice] = useState({});
    const [calendarActions, setCalendarActions] = useState([]);
    const [saleVisitBefore, setSaleVisitBefore] = useState("");
    const [saleVisitAfter, setSaleVisitAfter] = useState("");
    const [rentVisitBefore, setRentVisitBefore] = useState("");
    const [rentVisitAfter, setRentVisitAfter] = useState("");
    const [rentVisitFreeSlot, setRentVisitFreeSlot] = useState("");
    const [saleVisitFreeSlot, setSaleVisitFreeSlot] = useState("");
    const [isSaleVisitBeforeEmpty, setIsSaleVisitBeforeEmpty] = useState("");
    const [isSaleVisitAfterEmpty, setIsSaleVisitAfterEmpty] = useState("");
    const [isRentVisitBeforeEmpty, setIsRentVisitBeforeEmpty] = useState("");
    const [isRentVisitAfterEmpty, setIsRentVisitAfterEmpty] = useState("");
    const [isSaleVisitFreeSlotEmpty, setIsSaleVisitFreeSlotEmpty] = useState("");
    const [isRentVisitFreeSlotEmpty, setIsRentVisitFreeSlotEmpty] = useState("");
    const [validationMessage, setValidationMessage] = useState("");
    const [isAcceptenceEmailDisabled, setIsAcceptenceEmailDisabled] = useState(false);
    const [isFreeSlotWhiseSyncEnabled, setIsFreeSlotWhiseSyncEnabled] = useState(false);
    const [officeList, setOfficeList] = useState([]);
    const [selectOffice, setSelectOffice] = useState("");
    const [file, setFile] = useState(null);
    const [uploadFileUrl, setUploadFileUrl] = useState(null);
    const [whiseAgents, setWhiseAgents] = useState([]);
    const [isManageVisitReqCustomEmail, setIsManageVisitReqCustomEmail] = useState(false);
    const [isSelectSpecificEmail, setIsSelectSpecificEmail] = useState("");
    const [isCustomEmail, setIsCustomEmail] = useState("");
    const [selectAgent, setSelectAgent] = useState("");
    const [isSelectSpecificEmailEmpty, setIsSelectSpecificEmailEmpty] = useState("");
    const [isSelectAgentEmpty, setIsSelectAgentEmpty] = useState("");
    const [isCustomEmailEmpty, setIsCustomEmailEmpty] = useState("");
    const [validationMessageEnableCustomEmail, setValidationMessageCustomEmail] = useState("");
    const [showConfirmationModel, setShowConfirmationModel] = useState(false);
    const [isSavedSyncingValueDifferent, setIsSavedSyncingValueDifferent] = useState(false);
    const [modalMessageLocalToWhiseSync, setModalMessageLocalToWhiseSync] = useState("");
    const [modalMessageWhiseToLocalSync, setModalMessageWhiseToLocalSync] = useState("");
    const [contactTitles, setContactTitles] = useState([]);
    const [contactTitlesEn, setContactTitlesEn] = useState([]);
    const [contactTitlesFr, setContactTitlesFr] = useState([]);
    const [contactTitlesNl, setContactTitlesNl] = useState([]);
    const [selectedTitles, setSelectedTitles] = useState([]);
    const [savedContactTitles, setSavedContactTitles] = useState("");
    const [isAutomaticSlotAccept, setIsAutomaticSlotAccept] = useState(false);

    var scrollToElement = document.getElementById("visitToSaleBefore");

    const getWhiseOffices = async () => {
        let url = "https://api.whise.eu/v1/admin/offices/list";

        const config = {
            headers: {
                'Authorization': `Bearer ${whiseUserToken}`,
                'Content-Type': 'application/json'
            },
        };

        //await axios.post(url, { }, config)
        await axios.post(url, { "clientId": clientId }, config)
            .then(response => {
                if (response.data.offices != undefined) {
                    setOfficeList(response.data.offices);
                    var _filteredOffice = response.data.offices.filter((item) => { return item.id == officeId });
                    setOffice(_filteredOffice[0]);
                    setSelectOffice(_filteredOffice[0].id);
                    getOfficesLogo(_filteredOffice[0].id);
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const changeHandlerFreeSlotWhiseSynchronization = (e) => {
        let checked = e.target.checked;
        if (checked) {
            setModalMessageLocalToWhiseSync(reduxLanguageTranslations ? reduxLanguageTranslations["confirmLocalToWhiseSyncMessage"] : "All the existing free slot will be synchronised in WHISE in the calendar of the agents. Note that we will only synchronise the free slot created on the next two months.");
        }
        else {
            setModalMessageWhiseToLocalSync(reduxLanguageTranslations ? reduxLanguageTranslations["confirmWhiseToLocalSyncMessage"] : "All the existing free slot in WHISE will be deleted from the agendas for the next 90 days. Free slots that are existing above this time will have to be deleted manually from the agendas.");
        }
        setShowConfirmationModel(true);
    }

    const handlerSaveSetting = async (e) => {
        e.target.setAttribute("disabled", true);
        e.target.style.cursor = "progress";
        document.querySelector("body").style.cursor = "progress";
        setValidationMessage("");
        setValidationMessageCustomEmail("");
        let flagEmpty = false;
        let flagEmptyEnableCustomEmail = false;
        if (saleVisitBefore == "") {
            setIsSaleVisitBeforeEmpty("empty");
            flagEmpty = true;
        }
        if (saleVisitAfter == "") {
            setIsSaleVisitAfterEmpty("empty");
            flagEmpty = true;
        }
        if (rentVisitBefore == "") {
            setIsRentVisitBeforeEmpty("empty");
            flagEmpty = true;
        }
        if (rentVisitAfter == "") {
            setIsRentVisitAfterEmpty("empty");
            flagEmpty = true;
        }
        if (rentVisitFreeSlot == "") {
            setIsRentVisitFreeSlotEmpty("empty");
            flagEmpty = true;
        }
        if (saleVisitFreeSlot == "") {
            setIsSaleVisitFreeSlotEmpty("empty");
            flagEmpty = true;
        }
        if ((isSelectSpecificEmail == "" || isSelectSpecificEmail == null) && isManageVisitReqCustomEmail) {
            setIsSelectSpecificEmailEmpty("empty");
            flagEmptyEnableCustomEmail = true;
        }
        if ((isCustomEmail == "" || isCustomEmail == null) && isManageVisitReqCustomEmail && isSelectSpecificEmail == 2) {
            setIsCustomEmailEmpty("empty");
            flagEmptyEnableCustomEmail = true;
        }
        //if ( (selectAgent == "" || selectAgent == null) && isManageVisitReqCustomEmail) {
        //    setIsSelectAgentEmpty("empty");
        //    flagEmptyEnableCustomEmail = true;
        //}

        if (flagEmpty == true) {
            setValidationMessage(reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageRequiredFieldsMessage"] : "Please fill the required fields");
            scrollToElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            e.target.removeAttribute("disabled");
            e.target.style.cursor = "";
            document.querySelector("body").style.cursor = "";
            return;
        }

        if (flagEmptyEnableCustomEmail == true) {
            setValidationMessageCustomEmail(reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageRequiredFieldsMessage"] : "Please fill the required fields");
            scrollToElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            e.target.removeAttribute("disabled");
            e.target.style.cursor = "";
            document.querySelector("body").style.cursor = "";
            return;
        }
        if (isSavedSyncingValueDifferent != isFreeSlotWhiseSyncEnabled) {
            if (isFreeSlotWhiseSyncEnabled) {
                await moveLocalEventsToWhise([+rentVisitFreeSlot, +saleVisitFreeSlot]);
            }
            else {
                await moveWhiseEventsToLocal([+rentVisitFreeSlot, +saleVisitFreeSlot]);
            }
        }

        //const selectedIds = selectedTitles?.map(item => item.value) || [];
        const commaSeparatedTitleIds = selectedTitles.length > 0 ? JSON.stringify(selectedTitles) : ""; //selectedIds.length > 0 ? selectedIds.join(',') : null;

        let settingsObj = {
            "SettingId": settingId == "" ? 0 : +settingId,
            "VisitToSaleBefore": +saleVisitBefore,
            "VisitToSaleAfter": +saleVisitAfter,
            "VisitToRentBefore": +rentVisitBefore,
            "VisitToRentAfter": +rentVisitAfter,
            "VisitToRentFreeSlot": +rentVisitFreeSlot,
            "VisitToSaleFreeSlot": +saleVisitFreeSlot,
            "OfficeId": +officeId,
            "IsAcceptenceEmailDisabled": isAcceptenceEmailDisabled,
            "SyncEventsToWhise": isFreeSlotWhiseSyncEnabled,
            "IsVisitRequestManagementEnabled": isManageVisitReqCustomEmail ? isManageVisitReqCustomEmail : null,
            "SendEmailTo": isManageVisitReqCustomEmail ? isSelectSpecificEmail : null,
            "CustomEmail": isManageVisitReqCustomEmail && isSelectSpecificEmail == 2 ? isCustomEmail : null,
            "MappedContactTitles": commaSeparatedTitleIds,
            "OfficesDetail": JSON.stringify(officeList),
            "automaticSlotAcceptation": isAutomaticSlotAccept
            //"ReqManagementOfAgent": isManageVisitReqCustomEmail ? selectAgent : null
        }
 
        if (isManageVisitReqCustomEmail && selectAgent) {
            settingsObj["ReqManagementOfAgent"] = selectAgent;
        }

        let url = variables.API_URL + `Settings/SaveSetting?`;

        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        axios.post(url, JSON.stringify(settingsObj), jsonconfig) // ASP.NET Core API endpoint with header
            .then(response => {
                if (response.status == 200) {
                    setIsSavedSyncingValueDifferent(isFreeSlotWhiseSyncEnabled)
                    showMessage("success", response.data);
                    saveAndUpdateOfficeLog();
                    e.target.removeAttribute("disabled");
                    e.target.style.cursor = "";
                    document.querySelector("body").style.cursor = "";
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
                e.target.removeAttribute("disabled");
                e.target.style.cursor = "";
                document.querySelector("body").style.cursor = "";
            });
    }

    const moveLocalEventsToWhise = async (freeSlotIds) => {
        const now = new Date();
        // Set startDate to today at 12:00:00 AM
        const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
        // Set endDate to the last second of the same day two months later
        const endDate = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate(), 23, 59, 59);

        let calendarActions = [...new Set([...freeSlotIds])];
        let localEvents = await getCalendarEventsFromDB(startDate, endDate, calendarActions);

        let eventIdsToRemove = [];

        if (localEvents.isValidRequest && localEvents.totalCount > 0) {
            // Use map to create an array of promises and await all of them
            await Promise.all(localEvents.calendars.map(async (event) => {
                let configration = {
                    CalendarActionId: event.calendarActionId,
                    StartDateTime: event.startDateTime,
                    EndDateTime: event.endDateTime,
                    AllDay: event.allDay,
                    Private: false,
                    Subject: event.subject,
                    UserIds: [event.userId],
                    EstateIds: [event.estateId],
                    ContactIds: [event.contactId],
                    Description1: event.description1
                };

                if (event.contactId) {
                    configration["ContactIds"] = [event.contactId];
                }
                else {
                    configration["ContactIds"] = [+user.user.contactId];
                }

                let calendarId = await addWhiseCalenderEvent(configration);

                if (calendarId) {
                    eventIdsToRemove.push(event.id);
                }
            }));

            // Now this will only run after all event IDs have been pushed
            if (eventIdsToRemove.length > 0) {
                await deleteCalendarEventFromDB(eventIdsToRemove);
            }
        }
    };

    //Get events saved in local database
    const getCalendarEventsFromDB = async (startDate, endDate, calendarActions) => {
        // Generate query string
        let payload = {
            clientId: clientId,
            startDate: startDate,
            endDate: endDate,
            calendarActions: `${calendarActions}`
        };

        let url = variables.API_URL + `LocalEvents/GetLocalEventsForSynching?`;

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, JSON.stringify(payload), config);

        return response.data;
    }

    const addWhiseCalenderEvent = async (body) => {
        let url = "https://api.whise.eu/v1/calendars/upsert";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, body, config);
        return response.data.calendarId;
    }

    const deleteCalendarEventFromDB = async (_eventIds) => {

        let url = variables.API_URL + `LocalEvents/DeleteEventsByIdWhileSync?`;

        let payload = {
            eventIds: _eventIds
        };

        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.post(url, payload, config);

        return response.data;
    }

    const moveWhiseEventsToLocal = async (freeSlotIds) => {
        const now = new Date();
        // Set startDate to today at 12:00:00 AM
        const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
        // Set endDate to the last second of the same day two months later
        const endDate = new Date(now.getFullYear(), now.getMonth() + 3, now.getDate(), 23, 59, 59);

        let calendarActions = [...new Set([...freeSlotIds])];
        let whiseEvents = await getWhiseCalendarEvents(startDate, endDate, calendarActions);

        if (whiseEvents.length > 0) {
            whiseEvents.forEach(async event => {
                let configration = {
                    StartDateTime: event.startDateTime,
                    EndDateTime: event.endDateTime,
                    AllDay: false,
                    Private: false,
                    Subject: event.subject
                };

                if (event.action) {
                    configration["CalendarActionId"] = event.action.id;
                }

                if (event.allDay) {
                    configration["AllDay"] = event.allDay;
                }

                if (event.estates) {
                    configration["EstateIds"] = [event.estates[0].estateId]
                }

                if (event.users) {
                    configration["UserIds"] = [event.users[0].userId]
                }

                if (event.contacts) {
                    configration["ContactIds"] = [event.contacts[0].contactId]
                }

                if (event.description1) {
                    configration["Description1"] = event.description1;
                }

                let calendarId = await addCalenderEventInDB(configration, event.id);

                if (calendarId) {
                    await deleteWhiseCalendarEvent(event.id);
                }
            })
        }
    }

    //Fetch events for selected estate from whise and DB
    const getWhiseCalendarEvents = async (startDate, endDate, calendarActions) => {
        var eventLimit = 300;
        var pageOffset = 0;
        let listOfEvents = [];

        let _response = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, calendarActions);

        if (_response.totalCount != undefined && _response.totalCount > 300) {
            listOfEvents.push(..._response.calendars);
            let _afterDivison = _response.totalCount / 300;
            let pages = Math.ceil(_afterDivison);
            for (let i = 1; i < pages; i++) {
                pageOffset = eventLimit * i + 1;
                let _eventResponse = await getWhiseCalendarEventsByPagination(eventLimit, pageOffset, startDate, endDate, calendarActions);
                if (_eventResponse.calendars != undefined && _eventResponse.calendars.length > 0) {
                    listOfEvents.push(..._eventResponse.calendars);
                }
            }
        }
        else if (_response.calendars != undefined && _response.calendars.length > 0) {
            listOfEvents.push(..._response.calendars);
        }

        return listOfEvents;
    }

    //Get events from whise with pagination
    //This method will hit twice if in first call event count is greater than 300
    const getWhiseCalendarEventsByPagination = async (eventLimit, pageOffset, startDate, endDate, calendarActions) => {

        let url = "https://api.whise.eu/v1/calendars/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            "Filter": {
                "DateTimeRange": {
                    "Min": startDate,
                    "Max": endDate
                },
                "CalendarActionIds": calendarActions
            },
            "Page": {
                "Limit": eventLimit,
                "Offset": pageOffset
            }
        };

        let response = await axios.post(url, body, config);

        return response.data;
    }

    const addCalenderEventInDB = async (body, whiseEventId) => {
        let url = variables.API_URL + "LocalEvents/SaveEventInDatabase?";
        const config = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            },
        };
        body.ClientId = clientId;

        //axios.post(url, body, config)
        //    .then(response => {
        //        if (response.data.calendarId != undefined) {
        //            deleteWhiseCalendarEvent(whiseEventId);
        //        }
        //    })
        //    .catch(error => {
        //        showMessage("error", error);
        //    });

        let response = await axios.post(url, body, config);
        return response.data.calendarId;
    }

    const deleteWhiseCalendarEvent = async (eventId) => {

        let url = "https://api.whise.eu/v1/calendars/delete";
        let headers = {
            'Authorization': `Bearer ${reduxClientToken}`,
            'Content-Type': 'application/json'
        };
        let body = {
            "CalendarIds": [+eventId]
        };

        let response = await axios.delete(url, { data: body, headers: headers });

        return response.data;
    }

    const handlerVisitToSaleBefore = (e) => {
        setSaleVisitBefore(e.target.value);
        setIsSaleVisitBeforeEmpty("");
    }

    const handlerVisitToSaleAfter = (e) => {
        setSaleVisitAfter(e.target.value);
        setIsSaleVisitAfterEmpty("");
    }

    const handlerVisitToRentBefore = (e) => {
        setRentVisitBefore(e.target.value);
        setIsRentVisitBeforeEmpty("");
    }

    const handlerVisitToRentAfter = (e) => {
        setRentVisitAfter(e.target.value);
        setIsRentVisitAfterEmpty("");
    }

    const handlerVisitToSaleFreeSlot = (e) => {
        setSaleVisitFreeSlot(e.target.value);
        setIsSaleVisitFreeSlotEmpty("");
    }

    const handlerVisitToRentFreeSlot = (e) => {
        setRentVisitFreeSlot(e.target.value);
        setIsRentVisitFreeSlotEmpty("");
    }

    const handlerResetSettings = () => {
        setSaleVisitBefore("");
        setSaleVisitAfter("");
        setRentVisitBefore("");
        setRentVisitAfter("");
        setSaleVisitFreeSlot("");
        setRentVisitFreeSlot("");
        setIsSaleVisitBeforeEmpty("");
        setIsSaleVisitAfterEmpty("");
        setIsRentVisitBeforeEmpty("");
        setIsRentVisitAfterEmpty("");
        setIsSaleVisitFreeSlotEmpty("");
        setIsRentVisitFreeSlotEmpty("");
        setValidationMessage("");
        setIsManageVisitReqCustomEmail(false);
        setIsSelectSpecificEmail("");
        setIsCustomEmail("");
        setSelectAgent("");
        setValidationMessageCustomEmail("");
        scrollToElement.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
    }

    const getOfficeSettings = () => {
        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/GetSetting?officeId=` + officeId;
        axios.get(url, jsonconfig) // ASP.NET Core API endpoint with headers
            .then(response => {
                if (response.data != null) {
                    var settings = response.data;
                    setSettingId(settings.settingId);
                    setSaleVisitBefore(settings.visitToSaleBefore);
                    setSaleVisitAfter(settings.visitToSaleAfter);
                    setRentVisitBefore(settings.visitToRentBefore);
                    setRentVisitAfter(settings.visitToRentAfter);
                    setRentVisitFreeSlot(settings.visitToRentFreeSlot);
                    setSaleVisitFreeSlot(settings.visitToSaleFreeSlot);
                    setIsAcceptenceEmailDisabled(settings.isAcceptenceEmailDisabled == null ? false : settings.isAcceptenceEmailDisabled);
                    setIsFreeSlotWhiseSyncEnabled(settings.syncEventsToWhise == null ? false : settings.syncEventsToWhise);
                    setIsSavedSyncingValueDifferent(settings.syncEventsToWhise == null ? false : settings.syncEventsToWhise);
                    setIsManageVisitReqCustomEmail(settings.isVisitRequestManagementEnabled);
                    setIsSelectSpecificEmail(settings.sendEmailTo);
                    setIsCustomEmail(settings.customEmail);
                    setSelectAgent(settings.reqManagementOfAgent);
                    setSavedContactTitles(settings.mappedContactTitles);
                    setIsAutomaticSlotAccept(settings.automaticSlotAcceptation);
                    
                    if (settings.officesDetail == "") {
                        getWhiseOffices();
                    }
                    else {
                        var _officesDetail = JSON.parse(settings.officesDetail);
                        setOfficeList(_officesDetail);
                        var _filteredOffice = _officesDetail.filter((item) => { return item.Id == officeId });
                        if (_filteredOffice.length > 0) {
                            setOffice(_filteredOffice[0]);
                            setSelectOffice(_filteredOffice[0].Id);
                            getOfficesLogo(_filteredOffice[0].Id);
                        }
                        else {
                            getWhiseOffices();
                        }
                    }
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const handlerSelectOffice = (e) => {
        const value = e.target.value;
        setSelectOffice(value);
        if (value != "") {
            let _filteredOffice = officeList.filter((item) => item.Id == value || item.id == value);
            setOffice(_filteredOffice[0]);
            getOfficesLogo(_filteredOffice[0].Id || _filteredOffice[0].id);
        }
    }

    const getOfficesLogo = (_officeId) => {

        let url = "";
        if (_officeId) {
            url = `${variables.API_URL}Settings/GetLogoByOfficeId/${_officeId}`;
        }
        else {
            url = `${variables.API_URL}Settings/GetLogoByOfficeId/${office.id || officeId}`;
        }

        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        axios.get(url, {}, config)
            .then(response => {
                const value = response.data;
                let imgUrl = ""
                if (value && value.logoUrl) {
                    let fileName = value.logoUrl.split("UploadedFiles/")[1];
                    imgUrl = `${variables.API_URL.split("/api")[0]}/UploadedFiles/${fileName}`;
                    setFile(imgUrl);
                    setUploadFileUrl(value.logoUrl);
                }
                else {
                    setFile("");
                    setUploadFileUrl("");
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    const handlerSelectSpecificEmail = (e) => {
        const value = e.target.value;
        setIsSelectSpecificEmail(value);
        if (value == 2) {
            setIsCustomEmail("");
        }
        setIsSelectSpecificEmailEmpty("");
    }

    const handlerSelectAgent = (e) => {
        const value = e.target.value;
        setSelectAgent(value);
        setIsSelectAgentEmpty("");
    }

    const handlerCustomEmail = (e) => {
        const value = e.target.value;
        setIsCustomEmail(value);
        setIsCustomEmailEmpty("");
    }

    const handlerEnableVisitReqCheckbox = (e) => {
        const value = e.target.checked;
        setIsManageVisitReqCustomEmail(value);
        if (value == true) {
            setIsSelectSpecificEmail("");
            setIsCustomEmail("");
            setSelectAgent("");
        }
    }

    const handlerChangeUploadOfficeLogo = async (e) => {
        const uploadFile = e.target.files[0];
        setFile(URL.createObjectURL(e.target.files[0]));

        const formData = new FormData();
        formData.append("files", uploadFile);
        formData.append("fileName", uploadFile.name);

        try {
            const url = `${variables.API_URL}DocumentUpload/UploadOfficeLogo`;
            const response = await axios.post(url, formData, {
                headers: {
                    Authorization: `Bearer ${user.tokenValue}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            setUploadFileUrl(response.data.urls[0]);
        } catch (error) {
            console.error("Upload error:", error);
        }
    }

    const saveAndUpdateOfficeLog = async () => {

        const jsonconfig = {
            headers: {
                'Authorization': `Bearer ${user.tokenValue}`,
                'Content-Type': 'application/json'
            }
        };
        const url = variables.API_URL + `Settings/SaveOrUpdateLogo`;

        const obj = {
            officeId: office.Id,
            logoUrl: uploadFileUrl
        }

        try {
            const response = await axios.post(url, obj, jsonconfig);
            const value = response.data;
        } catch (error) {
            console.error("Upload error:", error);
        }
    }

    const getAgents = async () => {
        let url = "https://api.whise.eu/v1/admin/representatives/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        axios.post(url, {}, config)
            .then(response => {
                setWhiseAgents(response.data.representatives);
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const getContactTitlesEn = async () => {
        let url = "https://api.whise.eu/v1/contacts/titles/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            LanguageId: "en-GB"
        }

        axios.post(url, body, config)
            .then(response => {
                if (response.data.isValidRequest) {
                    setContactTitlesEn(response.data.contactTitles);
                }
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const getContactTitlesFr = async () => {
        let url = "https://api.whise.eu/v1/contacts/titles/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            LanguageId: "fr-BE"
        }

        axios.post(url, body, config)
            .then(response => {
                if (response.data.isValidRequest) {
                    setContactTitlesFr(response.data.contactTitles);
                }
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const getContactTitlesNl = async () => {
        let url = "https://api.whise.eu/v1/contacts/titles/list";
        const config = {
            headers: {
                'Authorization': `Bearer ${reduxClientToken}`,
                'Content-Type': 'application/json'
            },
        };

        let body = {
            LanguageId: "nl-BE"
        }

        axios.post(url, body, config)
            .then(response => {
                if (response.data.isValidRequest) {
                    setContactTitlesNl(response.data.contactTitles);
                }
            })
            .catch(error => {
                showMessage("error", error);
            });
    }

    const handleConfirmWindowClose = () => {
        setShowConfirmationModel(false);
        setModalMessageLocalToWhiseSync("");
        setModalMessageWhiseToLocalSync("");
    }

    const callBackConfirmSyncOfFreeSlots = (selection, isCanceled) => {
        if (isCanceled == false) {
            setIsFreeSlotWhiseSyncEnabled(selection);
        }
        setShowConfirmationModel(false);
        setModalMessageLocalToWhiseSync("");
        setModalMessageWhiseToLocalSync("");
    }

    const handleChangeContactTitles = (selected) => {
        setSelectedTitles(selected);
    }

    useEffect(() => {
        if (whiseUserToken) {
            getOfficeSettings();
        }
    }, [clientId, whiseUserToken])

    useEffect(() => {
        if (actions != null && actions != undefined) {
            setCalendarActions(actions);
        }
    }, [actions])

    useEffect(() => {
        if (reduxClientToken) {
            getAgents();
            getContactTitlesEn();
            getContactTitlesFr();
            getContactTitlesNl();
        }
    }, [reduxClientToken, savedContactTitles])

    useEffect(() => {

        if (reduxSelectedLanguage && contactTitles.length > 0) {
            let existingTitles = [...contactTitles];

            let titlesWithLanguageChange = existingTitles.map(item => {
                let description = "";
                if (reduxSelectedLanguage == "nl-BE") {
                    description = item.labelNl;
                }
                else if (reduxSelectedLanguage == "fr-BE") {
                    description = item.labelFr;
                }
                else {
                    description = item.labelEn;
                }

                return { ...item, label: description }
            })
            setContactTitles(titlesWithLanguageChange);

            if (selectedTitles.length > 0) {
                const selectedIds = selectedTitles.map(t => t.value);
                let filteredByLanguage = titlesWithLanguageChange.filter(title => {
                    return selectedIds.includes(title.value);
                })
                setSelectedTitles(filteredByLanguage);
            }
        }
    }, [reduxSelectedLanguage])

    useEffect(() => {
        if (contactTitlesEn.length > 0 && contactTitlesFr.length > 0 && contactTitlesNl.length > 0) {

            let _contactTitlesInEng = [...contactTitlesEn];
            let _contactTitlesInFrench = [...contactTitlesFr];
            let _contactTitlesInDutch = [...contactTitlesNl];

            let _contactTitles = _contactTitlesInEng.map((item, i) => {
                let description = "";
                if (reduxSelectedLanguage == "nl-BE") {
                    description = _contactTitlesInDutch[i].shortDescription
                }
                else if (reduxSelectedLanguage == "fr-BE") {
                    description = _contactTitlesInFrench[i].shortDescription
                }
                else {
                    description = item.shortDescription
                }

                return { label: description, value: item.id, labelEn: item.shortDescription, labelFr: _contactTitlesInFrench[i].shortDescription, labelNl: _contactTitlesInDutch[i].shortDescription }
            })

            setContactTitles(_contactTitles);
            if (savedContactTitles != "" && savedContactTitles != null) {
                let filteredList = _contactTitles.filter(f => {
                    return savedContactTitles.indexOf(f.value) > -1
                })
                setSelectedTitles(filteredList);
            }
        }
    }, [contactTitlesEn, contactTitlesFr, contactTitlesNl])

    return (
        <div className="px-4">
            <div className="row">
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageCalendarSettingsLbl"] : "Calendar Settings"}<span className="text-danger login-field-error ms-2">{validationMessage}</span></span>
                    <div className="form-container mt-3 mb-4">
                        <div className="row">
                            <div className="col-sm-3">
                                <span className="form-heading">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSmartCalLabelsText"] : "SmartCal labels"}</span>
                            </div>
                            <div className="col-sm-3">
                                <span className="form-heading">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageFreeSlotLbl"] : "Free Slot"}</span>
                            </div>
                            <div className="col-sm-3">
                                <span className="form-heading">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageBeforeConfirmationLbl"] : "Before Confirmation"}</span>
                            </div>
                            <div className="col-sm-3">
                                <span className="form-heading">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageAfterConfirmationLbl"] : "After Confirmation"}</span>
                            </div>
                        </div>
                        <div className="row py-4 d-flex align-items-center">
                            <div className="col-3">
                                <span className="form-label">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageVisitToSaleLbl"] : "Visit (to Sale)"}</span>
                            </div>
                            <div className="col-3">
                                <select className={`form-select ${isSaleVisitFreeSlotEmpty}`} id="visitToSaleFreeSlot" value={saleVisitFreeSlot}
                                    onChange={handlerVisitToSaleFreeSlot}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                            <div className="col-3">
                                <select className={`form-select ${isSaleVisitBeforeEmpty}`} id="visitToSaleBefore" value={saleVisitBefore}
                                    onChange={handlerVisitToSaleBefore}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                            <div className="col-3">
                                <select className={`form-select ${isSaleVisitAfterEmpty}`} id="visitToSaleAfter" value={saleVisitAfter}
                                    onChange={handlerVisitToSaleAfter}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3 d-flex align-items-center">
                                <span className="form-label">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageVisitToRentLbl"] : "Visit (to Rent)"}</span>
                            </div>
                            <div className="col-sm-3">
                                <select className={`form-select ${isRentVisitFreeSlotEmpty}`} id="visitToRentFreeSlot" value={rentVisitFreeSlot}
                                    onChange={handlerVisitToRentFreeSlot}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                            <div className="col-sm-3">
                                <select className={`form-select ${isRentVisitBeforeEmpty}`} id="visitToRentBefore" value={rentVisitBefore}
                                    onChange={handlerVisitToRentBefore}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                            <div className="col-sm-3">
                                <select className={`form-select ${isRentVisitAfterEmpty}`} id="visitToRentAfter" value={rentVisitAfter}
                                    onChange={handlerVisitToRentAfter}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    {
                                        calendarActions.length > 0 ? calendarActions.map((item, index) => {
                                            return (
                                                <option value={item.id} key={index}>{item.name}</option>
                                            )
                                        }) :
                                            <option>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSelectAction"] : "Select Action"}</option>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageEmailLbl"] : "Emails"}</span>
                    <div className="form-container mt-1 mb-4">
                        <div className="form-group row align-items-center">
                            <div className="col-sm-12 col-md-4">
                                <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageDeactivateEmailLbl"] : "Deactivate the 'accepted visit confirmation' email"}
                                </label>
                            </div>
                            <div className="col-sm-12 col-md-3 d-flex">
                                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2" htmlFor={`radioradioYes`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioDisableAcceptEmail`} id={`radioYes`} checked={isAcceptenceEmailDisabled === true} onChange={(e) => setIsAcceptenceEmailDisabled(previous => !previous)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                                </label>
                                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0" htmlFor={`radioNo`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioDisableAcceptEmail`} id={`radioNo`} checked={isAcceptenceEmailDisabled === false} onChange={(e) => setIsAcceptenceEmailDisabled(previous => !previous)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <span className="form-title">Automatic Acceptation</span>
                    <div className="form-container mt-1 mb-4">
                        <div className="form-group row align-items-center">
                            <div className="col-sm-12 col-md-4">
                                <label htmlFor="officeName" className="form-group-label me-2 my-0">
                                    Automatic slot acceptation with email
                                </label>
                            </div>
                            <div className="col-sm-12 col-md-3 d-flex">
                                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0 me-2" htmlFor={`radioYesBtn`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioAutomaticSlotAccept`} id={`radioYesBtn`} checked={isAutomaticSlotAccept === true} onChange={(e) => setIsAutomaticSlotAccept(previous => !previous)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageYesRadioLbl"] : "Yes"}
                                </label>
                                <label className="modal-p-text-black asnwer-options-preview d-flex bg-white align-items-center w-50 line-height-0" htmlFor={`radioNoBtn`}>
                                    <input className="custom-radio me-2" type="radio" name={`radioAutomaticSlotAccept`} id={`radioNoBtn`} checked={isAutomaticSlotAccept === false} onChange={(e) => setIsAutomaticSlotAccept(previous => !previous)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNoRadioLbl"] : "No"}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["setttingPageConfigurationHeading"] : "Configurations"}</span><span className="text-danger login-field-error ms-2">{validationMessageEnableCustomEmail}</span>
                    <div className="form-container mt-1 mb-4">
                        <div className="form-group row align-items-center">
                            <div className="col-sm-12 col-md-12 d-flex">
                                <label className={`modal-p-text-black d-flex align-items-center`} htmlFor="checkboxSynchronization">
                                    <input className="form-check-input checkbox-green me-2 mt-0" type="checkbox" checked={isFreeSlotWhiseSyncEnabled} id="checkboxSynchronization" onChange={(e) => changeHandlerFreeSlotWhiseSynchronization(e)} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["setttingPageEnableFreeSlot"] : "Enable Free Slots Synchronization on Whise"}
                                </label>
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <div className="col-sm-4 col-md-4">
                                <label className={`modal-p-text-black d-flex align-items-center`} htmlFor="checkboxManageVisitReqCustomEmail">
                                    <input className="form-check-input checkbox-green me-2 mt-0" type="checkbox" checked={isManageVisitReqCustomEmail} id="checkboxManageVisitReqCustomEmail" onChange={handlerEnableVisitReqCheckbox} />
                                    {reduxLanguageTranslations ? reduxLanguageTranslations["settingPageEnableVisitReq"] : "Enable management of visit request by:"}
                                </label>
                            </div>
                            <div className={`col-sm-3 col-md-3 ${isManageVisitReqCustomEmail ? "d-block" : "d-none"}`}>
                                <select className={`form-select ${isSelectSpecificEmailEmpty}`} id="selectCustomEmail" value={isSelectSpecificEmail} onChange={handlerSelectSpecificEmail}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOpt"] : "Select option"}</option>
                                    <option value="1">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageEstateOfficeEmailOpt"] : "Estate office email"}</option>
                                    <option value="2">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOtherOpt"] : "Other"}</option>
                                </select>
                            </div>
                            <div className={`col-sm-5 col-md-5 ${isManageVisitReqCustomEmail && isSelectSpecificEmail == 2 ? "d-block" : "d-none"}`}>
                                <input className={`form-control ${isCustomEmailEmpty}`} value={isCustomEmail} onChange={handlerCustomEmail} />
                            </div>
                        </div>
                        <div className={`form-group row align-items-center pt-4 ${isManageVisitReqCustomEmail ? "d-flex" : "d-none"}`}>
                            <label htmlFor="officeName" className="col-sm-3 form-group-label my-0 justify-content-end">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageExceptionsLbl"] : "Exceptions:"}</label>
                            <div className="col-sm-1 col-md-1"></div>
                            <div className="col-sm-3 col-md-3">
                                <select className={`form-select ${isSelectAgentEmpty}`} id="agentList" value={selectAgent} onChange={handlerSelectAgent}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["calendarPageFilterDropdownAgentSelect"] : "Select Agent"}</option>
                                    {
                                        whiseAgents.length > 0 ? whiseAgents.map((item, i) => {
                                            return (
                                                <option value={item.id} data-agent={JSON.stringify(item)} key={i}>{item.firstName + " " + item.name}</option>
                                            )
                                        })
                                            :
                                            <></>
                                    }
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageHeadingBookingPageSettings"] : "Booking page Settings"}</span>
                    <div className="form-container mt-1 mb-4">
                        <label htmlFor="officeName" className="col-sm-4 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["labelMappingContactTitlesSettingsPage"] : "Mapping of Contact Titles"}</label>
                        <div className={`col-sm-5${selectedTitles.length > 0 ? " mb-2": ""}`}>
                            <MultiSelect
                                id="contactTitles"
                                value={selectedTitles.length > 0 ? selectedTitles : []}
                                options={contactTitles}
                                onChange={handleChangeContactTitles}
                                labelledBy="Select contact titles"
                                overrideStrings={{
                                    search: reduxLanguageTranslations ? reduxLanguageTranslations["searchPlaceholderForMultiSelect"] : "Search",
                                    selectAll: reduxLanguageTranslations ? reduxLanguageTranslations["reactMultiSelectSelectAllLabel"] : "Select All"
                                }}
                            />
                        </div>
                        <div className="">
                            {
                                selectedTitles.length > 0 ? selectedTitles.map(title => {
                                    return (
                                        <div className={`text-danger`}>{title.label} (ID {title.value})</div>
                                    )
                                })
                                    :
                                    <></>
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <span className="form-title">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageAgencyDetailsLbl"] : "Agency Details"}</span>
                    <div className="form-container mt-1">
                        <div className="form-group row align-items-center pt-2">
                            <label htmlFor="officeName" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageOfficeLbl"] : "Office"}</label>
                            <div className="col-sm-5">
                                <select className={`form-select`} id="officeList" value={selectOffice} onChange={handlerSelectOffice}>
                                    <option value="">{reduxLanguageTranslations ? reduxLanguageTranslations["settingPageSelectOfficeOption"] : "Select Office"}</option>
                                    {
                                        officeList.length > 0 ? officeList.map((item, index) => {
                                            return (
                                                <option value={item.id || item.Id} key={index}>{item.name || item.Name}</option>
                                            )
                                        }) :
                                            <></>
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <label htmlFor="officeName" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeNameLbl"] : "Office Name"}</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" id="officeName" defaultValue={office.name || office.Name} />
                            </div>
                            <label htmlFor="officeId" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeIdLbl"] : "Office ID"}</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" id="officeId" defaultValue={office.id || office.Id} />
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <label htmlFor="street" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageStreetLbl"] : "Street"}</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" id="street" defaultValue={office.address1 || office.Address1} />
                            </div>
                            <label htmlFor="number" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageNumberLbl"] : "Number"}</label>
                            <div className="col-sm-2">
                                <input type="text" className="form-control" id="number" defaultValue={office.number || office.Number} />
                            </div>
                            <label htmlFor="box" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageBoxLbl"] : "Box"}</label>
                            <div className="col-sm-3">
                                <input type="text" className="form-control" id="box" defaultValue={office.box || office.Box} />
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <label htmlFor="zip" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageZipLbl"] : "Zip"}</label>
                            <div className="col-sm-2">
                                <input type="text" className="form-control" id="zip" defaultValue={office.zip || office.Zip} />
                            </div>
                            <label htmlFor="city" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageCityLbl"] : "City"}</label>
                            <div className="col-sm-3">
                                <input type="text" className="form-control" id="city" defaultValue={office.city || office.City} />
                            </div>
                            <label htmlFor="country" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageCountryLbl"] : "Country"}</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" id="country" defaultValue={office.countryId || office.CountryId} />
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <label htmlFor="officeTel" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeTelLbl"] : "Office tel"}</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" id="officeTel" defaultValue={office.telephone || office.Telephone} />
                            </div>
                            <label htmlFor="officeMobile" className="col-sm-2 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeMobileLbl"] : "Office mobile number"}</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" id="officeMobile" defaultValue={office.mobile || office.Mobile} />
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <label htmlFor="officeEmail" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeEmailsLbl"] : "Office Emails"}</label>
                            <div className="col-sm-4">
                                <input type="text" className="form-control" id="officeEmail" defaultValue={office.email || office.Email} />
                            </div>
                            <label htmlFor="officeWebsite" className="col-sm-2 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageOfficeWebsiteLbl"] : "Office Website"}</label>
                            <div className="col-sm-5">
                                <input type="text" className="form-control" id="officeWebsite" defaultValue={office.website || office.Website} />
                            </div>
                        </div>
                        <div className="form-group row align-items-center pt-4">
                            <label htmlFor="urlLink" className="col-sm-1 form-group-label my-0">{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageUrllinkLbl"] : "Or URL link"}</label>
                            <div className="col-sm-6">
                                <input type="text" className="form-control" id="urlLink" defaultValue={clientSettings != null && clientSettings.logoUrl != undefined ? clientSettings.logoUrl : ""} readOnly />
                            </div>
                            {
                                file != null ?
                                    <div className="col-sm-2">
                                        <img src={file != null ? file : ""} className="mw-100" style={{ maxHeight: "52px" }} />
                                    </div>
                                    :
                                    <></>
                            }
                            <div className="col-sm-3">
                                <input type="file" className="form-control" id="uploadOfficeLogo" onChange={handlerChangeUploadOfficeLogo} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row pt-4 pb-5">
                <div className="col-12 text-center">
                    <button className="site-btn" onClick={handlerResetSettings}>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageResetBtnText"] : "Reset"}</button>
                    <button className="site-btn ms-2" onClick={handlerSaveSetting}>{reduxLanguageTranslations ? reduxLanguageTranslations["settingsPageSaveBtnText"] : "Save"}</button>
                </div>
            </div>
            <ConfirmSynchronization showConfirmWindow={showConfirmationModel} handleConfirmWindowClose={handleConfirmWindowClose} callBackConfirmSyncOfFreeSlots={callBackConfirmSyncOfFreeSlots} messageLocalToWHise={modalMessageLocalToWhiseSync} messageWhiseToLocal={modalMessageWhiseToLocalSync} />
        </div>
    )
}